module.exports = __webpack_public_path__ + "img/newspapers_button_big_down.c5f47bf6.png";